import { useRegisteredDragSource } from './73d195fdc53def4c63ebe0e43a98aebeadba611c18266ed382dea4972106a7ce.cfe-internal.js';
import { useOptionalFactory } from '../64a12a69d5d7c389d785a0a93b9c902a9672f22afbeb72d068e9ed9cec90f744.cfe-internal.js';
import { useDragSourceMonitor } from './c88f3fa92a6a7f3d4f31fb9fe6e7c71a8e772c03634b59ad812dd4c35edf27d9.cfe-internal.js';
import { useDragSourceConnector } from './29bb21830945315ba6f52bd83b5a787163a3fd20312781410eb86741da857a7e.cfe-internal.js';
import { useCollectedProps } from '../41c5075c709f9b2fe49407e3797456748c9c163ab6d486622b31fbbca6106b1f.cfe-internal.js';
import { useConnectDragSource, useConnectDragPreview } from './f86edb9156b3cd176c3142c9c3d760d84c5b2b24fa0a2d857d8589062367da0a.cfe-internal.js';
import { invariant } from '../../../../../@react-dnd/invariant/dist/esm/d3abb5e672e7778a38d58eaa2ecad8bcd52c0adee27175788c7c8d2b86512d43.cfe-internal.js';

/**
 * useDragSource hook
 * @param sourceSpec The drag source specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */
function useDrag(specArg, deps) {
  var spec = useOptionalFactory(specArg, deps);
  invariant(!spec.begin, "useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)");
  var monitor = useDragSourceMonitor();
  var connector = useDragSourceConnector(spec.options, spec.previewOptions);
  useRegisteredDragSource(spec, monitor, connector);
  return [useCollectedProps(spec.collect, monitor, connector), useConnectDragSource(connector), useConnectDragPreview(connector)];
}

export { useDrag };
